import { getColorFromSCSS } from '@/helpers/styles/getColorFromSCSS';

const BACKGROUND_IMAGE_GRADIENT_CONFIG = {
  bottomer: {
    color: getColorFromSCSS('gray-light-2'),
    endAlpha: 0.58,
    middleAlpha: 0.74,
    startAlpha: 1,
  },
  topper: {
    color: getColorFromSCSS('gray-light-2'),
    endAlpha: 0,
    middleAlpha: 0.97,
    startAlpha: 1,
  },
} as const;

export default BACKGROUND_IMAGE_GRADIENT_CONFIG;
